import Swiper from "swiper";
import { Navigation } from "swiper/modules";

new Swiper(".tg-testimonials__swiper", {
    modules: [Navigation],
    spaceBetween: 15,
    slidesPerView: 'auto',
    centeredSlides: true,
    initialSlide: 1,
    navigation: {
        nextEl: ".tg-testimonials__swiper-next",
        prevEl: ".tg-testimonials__swiper-prev",
    },
    breakpoints: {
        500: {
            centeredSlides: true,
            initialSlide: 2,
            spaceBetween: 15,
        },
        768: {
            centeredSlides: true,
            initialSlide: 2,
            spaceBetween: 30,
        },
        992: {
            centeredSlides: true,
            initialSlide: 3,
            spaceBetween: 30,
        },
    },
});
